import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DashboardRestService } from '../dashboard-rest.service';
import { AuthenticationService } from '../../../libraries/libraries.module';
import { formatRupiah } from 'apps/admin-web/src/app/shared/utils';
import Swal from 'sweetalert2';
import { DashboardCommunicationService } from '../dashboard-communication.service';

declare var snap: any;

@Component({
  selector: 'app-membership-invoice-modal',
  templateUrl: 'membership-invoice-modal.component.html',
  styleUrls: ['./membership-invoice-modal.component.scss']
})
export class MembershipInvoiceModal implements OnInit {
  formatRupiah = formatRupiah;
  isLoading: boolean = false;
  isDealership: boolean = false;
  isOpen: boolean = false;
  totalRentalPrice: number = 0;
  currentMonth: string = new Date().toLocaleString('id-ID', { month: 'long' });

  membershipInvoiceData: {
    customerName: string;
    motorcycleNumber: string;
    chassisNumber: string;
    batteryCode: string;
    motorcycleType: string;
    billingMonth: string;
    rentalPrice: number;
  }[] = [];

  isProcessing: boolean = false;

  formatMonthYear(dateString: string): string {
    const date = new Date(dateString);
    const options: Intl.DateTimeFormatOptions = { month: 'long', year: 'numeric' };
    return date.toLocaleDateString('id-ID', options);
  }

  openModal() {
    this.isOpen = true;
    this.getMembershipInvoiceData();
  }

  closeModal() {
    this.isOpen = false;
  }

  getMembershipInvoiceData() {
    this.isLoading = true;
    this._DashboardRest.getMembershipInvoice().subscribe({
      next: (res) => {
        this.membershipInvoiceData = res.data;
        this.isLoading = false;
        this.totalRentalPrice = this.membershipInvoiceData.reduce((total, item) => total + item.rentalPrice, 0);
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: err?.response?.data?.message || 'Something went wrong!',
        });
        this.isLoading = false;
      }
    });
  }

  constructor(
    private _DashboardRest: DashboardRestService, 
    public _authentication: AuthenticationService, 
    private _dashboardCommunication: DashboardCommunicationService
  ) {
  }

  // Open Midtrans Snap popup
  openSnap(id: string, snapToken: string) {
    snap.pay(snapToken, {
      onSuccess: (result: any) => {
        console.log('Payment success:', result);
        Swal.fire({
          icon: 'success',
          title: 'Payment Success!',
          text: 'Your top-up has been processed successfully.',
          confirmButtonText: 'OK'
        });
        this.isProcessing = false;
        this._DashboardRest.updateTransactionId(id, result.transaction_id).subscribe({
          next: () => {
            this._dashboardCommunication.triggerTransactionHistoryRefresh();
            this.closeModal();
          },
          error: (error) => {
            console.error('Error updating transaction ID:', error);
          }
        });
      },
      onPending: (result: any) => {
        console.log('Payment pending:', result);
        Swal.fire({
          icon: 'info',
          title: 'Payment Pending',
          text: 'Your payment is being processed. Please wait for confirmation.',
          confirmButtonText: 'OK'
        });
        this.isProcessing = false;
        this._DashboardRest.updateTransactionId(id, result.transaction_id).subscribe({
          next: () => {
            this._dashboardCommunication.triggerTransactionHistoryRefresh();
            this.closeModal();
          },
          error: (error) => {
            console.error('Error updating transaction ID:', error);
          }
        });
      },
      onError: (result: any) => {
        console.log('Payment error:', result);
        Swal.fire({
          icon: 'error',
          title: 'Payment Failed',
          text: 'Your payment could not be processed. Please try again.',
          confirmButtonText: 'OK'
        });
        this.isProcessing = false;
      },
      onClose: () => {
        console.log('Payment popup closed');
        this.isProcessing = false;
      }
    });
  }

  processPayment() {
    this.isProcessing = true;

    const payload = {
      subtotal: this.totalRentalPrice,
      fee: 0,
      total: this.totalRentalPrice, // Assuming fee is 0 for now
    }

    this._DashboardRest.getSnapTokenMembership(payload).subscribe({
      next: (response: { transactionHistory: any, token: string, redirectUrl: string }) => {
        const id = response.transactionHistory._id;
        this.openSnap(id, response.token);
      },
      error: error => {
        this.isProcessing = false;
        Swal.fire({
          icon: 'error',
          title: 'Payment Failed',
          text: 'Failed to initialize payment. Please try again.',
          confirmButtonText: 'OK'
        });
      }
    });
  }

  ngOnInit(): void {
    
  }
}
